import { render, staticRenderFns } from "./eventdetail.vue?vue&type=template&id=5a82e848&scoped=true"
import script from "./eventdetail.vue?vue&type=script&lang=js"
export * from "./eventdetail.vue?vue&type=script&lang=js"
import style0 from "./eventdetail.vue?vue&type=style&index=0&id=5a82e848&prod&scoped=true&lang=css"
import style1 from "./eventdetail.vue?vue&type=style&index=1&id=5a82e848&prod&lang=css"
import style2 from "./eventdetail.vue?vue&type=style&index=2&id=5a82e848&prod&scoped=true&lang=css"
import style3 from "./eventdetail.vue?vue&type=style&index=3&id=5a82e848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a82e848",
  null
  
)

export default component.exports